import { render } from "./StatsBuilderElementsPanel.vue?vue&type=template&id=382f3716&scoped=true"
import script from "./StatsBuilderElementsPanel.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderElementsPanel.vue?vue&type=script&lang=ts"

import "./StatsBuilderElementsPanel.vue?vue&type=style&index=0&id=382f3716&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-382f3716"

export default script